// TODO: [PROF-5358] Bring back analytics page with tabs, routing etc.

import { Button } from "PFComponents/button";
// import PageTabs from "PFComponents/page/page_tabs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./analytics_page.module.scss";
import { useAnalyticsContext } from "./context/analytics_context";
import { InsightsPage } from "./parts/insights_page/insights_page";
import { ReportsPage } from "./parts/reports_page";
import { TemplatesSidePanel } from "./parts/templates_side_panel/tempates_side_panel";
import { useAnalyticsModalContext } from "./parts/top_actions_panel/analytics_modal_context_provider";
import { ExportWizardModal } from "./parts/top_actions_panel/export_wizard_modal";
import { ExportType } from "./types/export_analytics";

export const AnalyticsPage = () => {
  const {
    state: { isOpen },
    open
  } = useAnalyticsModalContext();
  const [isManageTemplatesOpen, setIsManageTemplatesOpen] = useState(false);
  const { activeTab } = useAnalyticsContext();

  const { t } = useTranslation(["insights", "translation"]);

  // const tabs = useRef([
  //   // { id: "insights", displayElement: t("insights:tabs.insights") },
  //   { id: "reports", displayElement: t("insights:tabs.reports") }
  // ]);

  const TabComponent = {
    insights: InsightsPage,
    reports: ReportsPage
  }[activeTab];

  return (
    <div className={css.container}>
      <div className={css.header}>{t("translation:navBar.items.reports")}</div>
      <div className={css.wrap}>
        {/* <PageTabs
          items={tabs.current}
          handleClick={(value) => changeTab(value.id)}
          active={activeTab}
          rootClassName={css.tabs}
        /> */}
        <div className={css.actionButtons}>
          <Button kind="secondary" onClick={() => open({ exportType: ExportType.Custom })}>
            {t("insights:actionButtons.createReport")}
          </Button>
          <Button kind="secondary" onClick={() => setIsManageTemplatesOpen(true)}>
            {t("insights:actionButtons.manageTemplates")}
          </Button>
        </div>
      </div>
      <TabComponent />
      <TemplatesSidePanel show={isManageTemplatesOpen} onClose={() => setIsManageTemplatesOpen(false)} />
      {isOpen && <ExportWizardModal />}
    </div>
  );
};
